import { AnyAction } from 'redux';
import { Categories, getCategories } from '@ttstr/api';
import { ThunkActionCreator } from '.';


export const CATEGORIES_REQUESTED = 'CATEGORIES.CATEGORIES_REQUESTED';
export const CATEGORIES_ALREADY_RECEIVED = 'CATEGORIES.CATEGORIES_ALREADY_RECEIVED';
export const CATEGORIES_RECEIVED = 'CATEGORIES.CATEGORIES_RECEIVED';
export const CATEGORIES_FAILED = 'CATEGORIES.CATEGORIES_FAILED';

export interface CategoriesReceivedAction extends AnyAction {
  payload: {
    categories: Categories;
  };
}

let requestCategoriesAbortController: AbortController;

export const requestCategories: ThunkActionCreator = () => async (dispatch) => {
  if (requestCategoriesAbortController) requestCategoriesAbortController.abort();

  requestCategoriesAbortController = new AbortController();
  dispatch({
    type: CATEGORIES_REQUESTED,
  });

  try {
    const categories = await getCategories({ signal: requestCategoriesAbortController.signal });
    dispatch<CategoriesReceivedAction>({
      type: CATEGORIES_RECEIVED,
      payload: {
        categories,
      },
    });
  } catch (error) {
    dispatch({
      type: CATEGORIES_FAILED,
      payload: {
        error,
      },
    });
  }
};
